<template>
  <div v-if ="stats && stats.length > 0" style="padding: 0 20px;">
    <small><b>Accesos al enlace del mensaje de bienvenida:</b></small>
    <br />
    <p><small style="padding-left: 20px;color: #CCCCCC;">Total:</small> {{total}}</p>
    <p 
      v-for="(item, index) of stats"
      :key="index"
    >
      <small style="color: #CCCCCC;padding-left: 20px;">{{ `${item.Year}/${item.Month}` }}:</small> {{item.Count}}
    </p>
  </div>
  <div v-else>
    <small>no hay datos para mostrar</small>
  </div>
</template>
<script>
import axios from 'axios'
import utils from '@/services/utils'
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    stats: null,
    total: null
  }),
  watch: {
    id () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      this.loading = true
      this.stats = null
      const url = utils.getAPIURL(`stats-welcome-modal/${this.id}`, true)//.replace('undefined', this.id)
      axios.get(url)
        .then(response => {
          this.stats = response && response.data ? response.data : null
          if (this.stats) this.total = this.stats.reduce((s, a) => {
              return s + a.Count;
            }, 0)
            sum(x => x.Count)
          this.loading = false
        })
        .catch((error) => {
          console.log('jjj', error)
          this.loading = false
        })
    },
  },
}
</script>

